module.exports = __webpack_public_path__ + "static/media/slideshow-23.091d55be.jpeg";